import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Route} from "react-router-dom";
import PrivateRoute from './components/private-route';
import { LocalizeProvider } from 'react-localize-redux';
import Login from "./components/login";
import PasswordReset from "./components/password-reset";
import Register from "./components/register";
import Syllabus from "./components/syllabus";
import Dashboard from "./components/dashboard";
import ReportStudentAverage from "./components/reports/report-student-average";
import ReportStudentLessonAverage from "./components/reports/report-student-lesson-average";
import ReportResults from "./components/reports/report-results";
import UpdateInformation from "./components/update-information";
import ProfileRegister from "./components/profile-register";
import ProfileUpdate from "./components/profile-update";
import LandingPage from "./components/landing-page";
import DownloadPage from "./components/download-page";
import SubscriptionSteps from "./components/subscription-steps";
import SubscriptionDownload from "./components/forms/form-subscription-download";

class App extends React.Component {


    render() {
        return (
            /** Set the routes of each page with the renders **/

            <LocalizeProvider>
                <Router>
                    <div>
                        <Route exact path="/" component={LandingPage}/>
                        <Route path="/download" component={DownloadPage}/>
                        <Route path="/login" component={Login}/>
                        <Route path="/password-reset" component={PasswordReset}/>
                        <Route path="/register" component={Register}/>
                        <Route path="/subscription-steps" component={SubscriptionSteps}/>
                        <Route path="/subscription-download" component={SubscriptionDownload}/>

                        {/* Stablish the private routes. The user should be */}
                        <PrivateRoute path="/syllabus" component={Syllabus}/>
                        <PrivateRoute path="/dashboard" component={Dashboard} />
                        <PrivateRoute path="/report-average" component={ReportStudentAverage}/>
                        <PrivateRoute path="/report-lesson-average" component={ReportStudentLessonAverage}/>
                        <PrivateRoute path="/report-results" component={ReportResults}/>
                        <PrivateRoute path="/update-information" component={UpdateInformation}/>
                        <PrivateRoute path="/profile-register" component={ProfileRegister}/>
                        <PrivateRoute path="/profile-update" component={ProfileUpdate}/>
                    </div>
                </Router>
            </LocalizeProvider>
        )
    };
}
/** Exact prop is for match exactly at it is. For example /login is valid, /login/2 is not valid**/

// Set the router as Main APP so the app know where it can go
ReactDOM.render(<App />, document.getElementById("root"));


// WEBPACK FOOTER //
// ./src/index.js